import { render, staticRenderFns } from "./DialogPreviewNews.vue?vue&type=template&id=1ee7e8d7&scoped=true&"
import script from "./DialogPreviewNews.vue?vue&type=script&lang=js&"
export * from "./DialogPreviewNews.vue?vue&type=script&lang=js&"
import style0 from "./DialogPreviewNews.vue?vue&type=style&index=0&id=1ee7e8d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee7e8d7",
  null
  
)

export default component.exports